import { useAppContext } from '../../services/app-context.service';
const BDT = new Intl.NumberFormat('en-IN');
const CartTotal: React.FC = () => {
    const { cart, settings } = useAppContext()
    const advancePaymentPercent = settings?.advance_payment_percent ?? 70
    const advancePaymentAmount = Math.ceil(cart.total * (advancePaymentPercent / 100))
    if (cart.itemCount < 1) {
        return null
    }
    return <div id="cart-total">
        <div>
            {cart.itemCount} Products
        </div>
        <div>
            Total : <span>{BDT.format(cart.total)} /=</span>
        </div>
        <div>
            Advance {advancePaymentPercent}% : <span>{BDT.format(advancePaymentAmount)} /=</span>
        </div>
    </div>
};

export default CartTotal;
